import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import {DialogModule} from 'primeng/dialog';
import {TableModule} from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import {TooltipModule} from 'primeng/tooltip';

import { SharedModule } from '../shared/shared.module';
import { APORoutingModule } from './apo.routes';

import { AddressListComponent } from './components/address-list/address-list.component';

import { OwnerListComponent } from './components/owner-list/owner-list.component';
import { ParcelListComponent } from './components/parcel-list/parcel-list.component';
import { SearchResultsPanelComponent } from './components/apo-search-results-panel/apo-search-results-panel.component';
import { MultiApoScreenComponent } from './screens/multi-apo-screen/multi-apo-screen.component';
import { AddressCardComponent } from './components/address-card/address-card.component';
import { ParcelCardComponent } from './components/parcel-card/parcel-card.component';
import { OwnerCardComponent } from './components/owner-card/owner-card.component';
import { EditAddressFormComponent } from './components/edit-address-form/edit-address-form.component';
import { EditParcelFormComponent } from './components/edit-parcel-form/edit-parcel-form.component';
import { EditOwnerFormComponent } from './components/edit-owner-form/edit-owner-form.component';


@NgModule({
    declarations: [
        AddressListComponent,
        OwnerListComponent,
        ParcelListComponent,
        SearchResultsPanelComponent,
        MultiApoScreenComponent,
        AddressCardComponent,
        ParcelCardComponent,
        OwnerCardComponent,
        EditAddressFormComponent,
        EditParcelFormComponent,
        EditOwnerFormComponent
    ],
    imports: [
        APORoutingModule,
        ButtonModule,
        CardModule,
        DialogModule,
        CommonModule,
        SharedModule,
        TableModule,
        ToastModule,
        TooltipModule
        ],
    exports: [

    ],
    providers: [
      DatePipe
    ]
})
export class APOModule {}
